export default "__VITE_ASSET__CmELTPje__"